import React, { useCallback } from "react";
import useGetBuildSpinnerFrame from "../../../../hooks/shared/spin/useGetBuildSpinnerFrame";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import Separator from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Separator";
import Spacer from "../../../../../../../common-deprecated/styles/v2/lexus/utilities/Spacer";
import * as Image from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import * as Text from "../../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import { IconArrowLeftLong } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { useBnbSelector } from "../../../../redux/store";
import { generateImageSet } from "../../../../utils/typedUtils";
import PaymentDetails from "../../common/PaymentDetails";
import * as Styles from "./styles/Buy";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import BasketHeader from "../../common/basket/content/BasketHeader";
import ButtonPrimary from "../../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import ButtonWithIcon from "../../../../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import useStepUrl from "../../../../hooks/shared/actions/useStepUrl";

type PropsType = {
    buyCar: () => void;
};

const PaymentPanel = (props: PropsType): JSX.Element => {
    const { buyCar } = props;
    const { model, grade } = useBnbSelector((state) => state.car);
    const { colour } = useBnbSelector((state) => state.basket);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const genericePriceDisclaimerBuy = useBnbOptionalLabel("genericPriceDisclaimerBuy");

    const summaryStep = useStepUrl(NavStep.Summary, undefined, true);

    const { getImage, cacheKey } = useGetBuildSpinnerFrame(false);
    const getFrame = useCallback(() => {
        return generateImageSet(
            (width: number, height: number) =>
                getImage(width, height, 2, { bgColour: theme.colors.mist.replace("#", ""), padding: 0 }),
            800,
            460,
        ); // same size as mobile basket
    }, [cacheKey]);

    return (
        <>
            <Styles.Panel>
                <Styles.ImageWrapper>
                    <Image.ImageFluid
                        src={getFrame().src}
                        srcSet={getFrame().srcset}
                        sizes=""
                        draggable={false}
                        alt={`${model.name} ${grade.name} ${colour.name}`}
                    />
                </Styles.ImageWrapper>
                <Styles.BasketTitle>
                    <BnbLabel label="basketYourModel" params={{ name: model.webtitleSectionName }} />
                </Styles.BasketTitle>

                <BasketHeader />
                <Separator my={3} />
                <PaymentDetails cashPriceDisclaimer={genericePriceDisclaimerBuy} />

                <Styles.ButtonWrapper>
                    <ButtonPrimary fullWidth onClick={buyCar} classNames="build-primary-button">
                        <BnbLabel
                            label={financeOption === "cash" ? "buyBuyNow" : "buyBuyNowMonthly"}
                            fallbackLabel="buyBuyNow"
                        />
                    </ButtonPrimary>
                    <ButtonWithIcon hasIconLeft href={summaryStep.href}>
                        <Text.IconButton>
                            <BnbLabel label="buyBackToSummary" />
                        </Text.IconButton>
                        <IconArrowLeftLong />
                    </ButtonWithIcon>
                </Styles.ButtonWrapper>
            </Styles.Panel>
            <Spacer mt={3} />
        </>
    );
};

export default PaymentPanel;
